import { styled, ThemedColorProps } from "styles";
import {
  space,
  flex,
  alignSelf,
  color,
  fontSize,
  textAlign,
  FontSizeProps,
  FlexProps,
  SpaceProps,
  AlignSelfProps,
  TextAlignProps,
  fontWeight,
  FontWeightProps
} from "styled-system";

type Props = SpaceProps &
  FlexProps &
  AlignSelfProps &
  ThemedColorProps &
  FontSizeProps &
  TextAlignProps &
  FontWeightProps;

export default styled<Props, "div">("div")`
  ${space}
  ${flex}
  ${alignSelf}
  ${color}
  ${fontSize}
  ${textAlign}
  ${fontWeight}
`;



// WEBPACK FOOTER //
// ./src/components/ui/Text.ts